<script setup lang="ts">
import IconMiliLogo from '@/shared/public/IconMiliLogo.svg'
</script>

<template>
  <header
    class="flex h-52 shrink-0 grow-0 select-none items-stretch justify-between border-b border-solid border-gray-200 bg-white pr-12 lg:h-48 lg:pl-12 lg:pr-16"
  >
    <nav class="relative flex w-1/2 shrink grow items-center">
      <div class="skeleton lg:w-100 rounded-4 ml-4 h-32 w-40 lg:mx-16"></div>
      <div class="skeleton lg:w-100 rounded-4 ml-4 h-32 w-40 lg:mx-16"></div>
      <div class="skeleton lg:w-100 rounded-4 ml-4 h-32 w-40 lg:mx-16"></div>
    </nav>
    <div class="flex shrink-0 grow-0 items-center lg:hidden">
      <IconMiliLogo height="18" />
    </div>
    <div class="flex w-1/2 shrink grow items-center justify-end">
      <div class="skeleton rounded-4 w-76 mr-12 h-32" />
      <div class="skeleton h-32 w-32 rounded-full" />
    </div>
  </header>
</template>
